import { FC, LabelHTMLAttributes, ReactNode } from 'react';
import ToolTipIcon from 'assets/tooltip-icon.svg';

import { Tooltip } from 'components/Tooltip';

import classes from './label.module.css';

interface LabelTooltipProps {
  id: string;
  tooltipText: string;
}

const LabelTooltip: FC<LabelTooltipProps> = ({ id, tooltipText }) => (
  <>
    <span data-tooltip-id={id} className={classes.tooltipIcon}>
      <img src={ToolTipIcon} alt="tool tip" />
    </span>
    <Tooltip id={id} place="top" content={tooltipText} />
  </>

);

interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  htmlFor: string;
  children: ReactNode;
  className?: string;
  labelText: string;
  labelTextClassName?: string;
  tooltipText?: string;
}

export const Label: FC<LabelProps> = ({
  id, htmlFor, children, className, labelText, labelTextClassName, tooltipText, ...rest
}) => (
  <label htmlFor={htmlFor} className={className || classes.label} {...rest}>
    <div className={labelTextClassName || classes.labelText}>
      <span>{labelText}</span>
      {tooltipText && <LabelTooltip id={id || `tooltip-id-${labelText}`} tooltipText={tooltipText} />}
    </div>
    {children}
  </label>
);
